import { Amplify } from "aws-amplify";
import axios from "axios";
import { backendConfig } from "../config/BackendConfig";
import { setBackendConfig } from "./AxiosInterceptor";

class BackendService {
  async getConfig(email) {
    let env = "";
    const NODE_ENV = process.env.NODE_ENV;
    const AMPLIFY_BUILD_ENV = process.env.REACT_APP_BUILD_ENV;
    if (NODE_ENV === "production") {
      if (AMPLIFY_BUILD_ENV === "DEV") {
        env = "DEV";
        backendConfig.PUBSUB_ENV = "dev";
      } else if (AMPLIFY_BUILD_ENV === "LABS") {
        env = "LABS";
        backendConfig.PUBSUB_ENV = "labs";
      } else if (AMPLIFY_BUILD_ENV === "QA") {
        env = "QA";
        backendConfig.PUBSUB_ENV = "qa";
      } else if (AMPLIFY_BUILD_ENV === "STG") {
        env = "STG";
        backendConfig.PUBSUB_ENV = "stg";
      } else if (AMPLIFY_BUILD_ENV === "UAT") {
        env = "UAT";
        backendConfig.PUBSUB_ENV = "qa";
      }
    } else {
      env = "DEV";
      backendConfig.PUBSUB_ENV = "dev";
    }

    await axios
      .post(
        backendConfig.CONFIG_API_URL,
        {
          config: "Env",
          environment: env,
          userEmailAddress: email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": backendConfig.CONFIG_API_KEY,
          },
        }
      )
      .then((response) => {
        const cognitoConfig = {
          aws_project_region: response?.data?.region,
          aws_cognito_identity_pool_id:
            response?.data?.cognito_identity_pool_id,
          aws_cognito_region: response?.data?.region,
          aws_user_pools_id: response?.data?.cognito_pool_id,
          aws_user_pools_web_client_id: response?.data?.user_pools_client_id,
        };

        backendConfig.API_URL = response?.data?.api_url;
        backendConfig.API_END_POINTS = response?.data?.endpoints;
        backendConfig.API_KEY = response?.data?.api_key;
        backendConfig.featureFlag = response?.data?.featureEnabledStatus;
        Amplify.configure(cognitoConfig);
        setBackendConfig();
        backendConfig.CURRENT_ENV = env;
      })
      .catch(function (error) {
        // console.log(error);
      });
  }
}
export default new BackendService();
